export default __webpack_public_path__ + "static/media/Nesha_Laser_0015_Laser_8.041d2e11.png";